import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore';

import { Form } from 'ui/components';
import { Select } from 'ui/components';

const initialState = {
  privilege: null,
  errorItems: null,
  items: [
    {
      item_name: '',
      quantity: '',
      weight: '',
      long: '',
      Wide: '',
      high: '',
      metric: '',
    },
  ],
};

const options = [
  { value: 'Aerospace Material', label: 'Aerospace Material' },
  {
    value: 'Hasil Pertanian / Buah / Sayuran',
    label: 'Hasil Pertanian / Buah / Sayuran',
  },
  {
    value: 'Hasil Peternakan / Daging / Ikan',
    label: 'Hasil Peternakan / Daging / Ikan',
  },
  {
    value: 'Otomotif / Sparepart / Mekanikal',
    label: 'Otomotif / Sparepart / Mekanikal',
  },
  { value: 'FMCG / Consumer Goods', label: 'FMCG / Consumer Goods' },
  {
    value: 'Peralatan Berat / Industrial',
    label: 'Peralatan Berat / Industrial',
  },
  { value: 'Oil & Gas / Bahan Kimia', label: 'Oil & Gas / Bahan Kimia' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Constructions Material', label: 'Constructions Material' },
  { value: 'Obat-obatan / Healthcare', label: 'Obat-obatan / Healthcare' },
  { value: 'Peralatan Medis', label: 'Peralatan Medis' },
  { value: 'Elektronik', label: 'Elektronik' },
  { value: 'Lain-lain', label: 'Lain-lain' },
];

export const UpdateItems = ({ data, errors, onUpdate }) => {
  const [{ errorItems, items }, setState] =
    React.useState(initialState);

  React.useEffect(() => {
    let newItem = [];

    if (items) {
      items?.forEach((item) => {
        if (
          item?.item_name &&
          (item?.quantity ||
          (item?.weight || item?.metric))
        ) {
          newItem.push({
            item: item?.item,
            item_name: item?.item_name,
            quantity: item?.quantity ? parseFloat(item?.quantity) : 0,
            weight: item?.weight ? parseFloat(item?.weight) : 0,
            long: item?.long ? parseFloat(item?.long) : null,
            Wide: item?.Wide ? parseFloat(item?.Wide) : null,
            high: item?.high ? parseFloat(item?.high) : null,
            metric: item?.metric ? parseFloat(item?.metric) : null,
          });
        }
      });
    }

    onUpdate(newItem);
  }, [items]);

  const $handleItemsChange = async (i, e) => {
    let newItems = [...items];

    if (e) {
      if (e?.target) {
        newItems[i][e?.target.name] = e.target.valueNumber
          ? e.target.valueNumber
          : e.target.value;
      } else {
        newItems[i]['item'] = e;
        newItems[i]['item_name'] = e.value;
      }
    } else {
      newItems[i]['item'] = null;
      newItems[i]['item_name'] = '';
    }

    if (newItems[i]['long'] && newItems[i]['Wide'] && newItems[i]['high']) {
      const m =
        ((parseFloat(newItems[i]['long']) *
          parseFloat(newItems[i]['Wide']) *
          parseFloat(newItems[i]['high'])) /
          4000);

      newItems[i]['metric'] = m?.toFixed(2);
    } else {
      newItems[i]['metric'] = null;
    }

    setState((prevState) => ({ ...prevState, items: newItems }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          itemOption: null,
          quantity: '',
          weight: '',
          long: null,
          Wide: null,
          high: null,
          metric: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);
    setState((prevState) => ({ ...prevState, items: newItems }));
  };


  React.useEffect(() => {
    if (data?.items) {
      let items = [];
      data?.items?.forEach((item) => {
        let option = null;
        // ini penanda bahwa tidak ada optisnnya
        let keyOptions = -1;

        _.each(options, function (i, key) {
          if (i?.value === item.item_name) {
            keyOptions = key;
            return;
          }
        });

        if (keyOptions >= 0) {
          option = options[keyOptions];
        } else {
          option = { value: item.item_name, label: item.item_name };
          options.push(option);
        }

        items.push({
          item: option,
          item_name: item?.item_name,
          quantity: parseFloat(item?.quantity),
          weight: parseFloat(item?.weight),
          long: item?.long ? parseFloat(item?.long) : null,
          Wide: item?.Wide ? parseFloat(item?.Wide) : null,
          high: item?.high ? parseFloat(item?.high) : null,
          metric: item?.m3 ? parseFloat(item?.m3) : null,
        });
      });
      setState((prevState) => ({ ...prevState, items: items }));
    }
  }, [data]);

  return (
    <>
      <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
        Informasi Item
      </div>
      <div className="border">
        {items?.map((e, i) => (
          <div
            className={cn('row align-items-end border-bottom py-3 m-0')}
            key={i}
          >
            <div className="col-11">
              <div className="row">
                <div
                  className='col-md-3'
                >
                  <label className={`form-label required`}>Komoditas</label>
                  <Select.Createable
                    isClearable
                    placeholder=""
                    classNamePrefix={errorItems ? 'is-invalid' : 'select'}
                    value={e?.item}
                    options={options}
                    name="item_name"
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={errorItems}
                  />
                </div>
                <div
                  className='col-md-2'
                >
                  <Form.Input
                    required
                    label="Koli"
                    name="quantity"
                    type="number"
                    value={e?.quantity}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={errorItems}
                  />
                </div>
                <div
                  className='col-md-2'
                >
                  <Form.Input
                    required={data?.shipment?.type === "ltl" ? true : false}
                    label="Berat (Kg)"
                    name="weight"
                    type="text"
                    value={e?.weight}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={errorItems}
                  />
                </div>
                <>
                  <div className="col-md-3">
                    <div className="row ">
                      <label className="form-label fs-8 ms-md-n2">
                        Dimensi (P x L x T) (cm)
                      </label>
                      <div className="col-4 p-md-0 pe-0">
                        <Form.Input
                          className="rounded-start rounded-0"
                          autoComplete="off"
                          pattern="[0-9]{0,50}"
                          name="long"
                          type="number"
                          value={e?.long}
                          onChange={(e) => $handleItemsChange(i, e)}
                        />
                      </div>
                      <div className="col-4 p-0">
                        <Form.Input
                          className="rounded-0"
                          autoComplete="off"
                          pattern="[0-9]{0,50}"
                          type="number"
                          name="Wide"
                          value={e?.Wide}
                          onChange={(e) => $handleItemsChange(i, e)}
                        />
                      </div>
                      <div className="col-4 p-md-0 ps-0">
                        <Form.Input
                          className="rounded-end rounded-0"
                          autoComplete="off"
                          pattern="[0-9]{0,50}"
                          name="high"
                          type="number"
                          value={e?.high}
                          onChange={(e) => $handleItemsChange(i, e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 pe-md-0">
                    <Form.Input
                      autoComplete="off"
                      pattern="[0-9]{0,50}"
                      label="Volumetrik (Kg)"
                      name="metric"
                      type="number"
                      disabled
                      value={e?.metric}
                      onChange={(e) => $handleItemsChange(i, e)}
                    />
                  </div>
                </>
              </div>
            </div>
            <div className="col-1">
              {i ? (
                <button
                  type="button"
                  className="btn btn-danger rounded p-2 mb-3"
                  style={{ minHeight: 36, minWidth: '100%' }}
                  onClick={() => $removeField(i)}
                >
                  <Fi.FiX />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary rounded p-2 mb-3"
                  style={{ minHeight: 36, minWidth: '100%' }}
                  onClick={() => $addMoreFields()}
                >
                  <Fi.FiPlus />
                </button>
              )}
            </div>
          </div>
        ))}

        {errors ? (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {errors}
        </div>
      ) : null}
      </div>
    </>
  );
};